import { Box, Typography } from "@mui/material";

import { GenericTableData } from "../../contexts/chat/type";

interface GenericTableDisplayProps {
  tables: GenericTableData[];
}

const renderCell = (value: unknown): string => {
  if (value === null || value === undefined) return "null";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export const GenericTableDisplay = ({ tables }: GenericTableDisplayProps) => {
  if (!tables || tables.length === 0) return null;

  return (
    <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
      {tables.map((table, tableIndex) => (
        <Box
          key={`${table.title}-${tableIndex}`}
          sx={{
            border: "1px solid",
            borderColor: "grey.300",
            borderRadius: 1,
            overflow: "hidden",
            backgroundColor: "background.paper",
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1,
              backgroundColor: "grey.100",
              borderBottom: "1px solid",
              borderColor: "grey.300",
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              {table.title}
            </Typography>
            {table.summary && (
              <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                {table.summary}
              </Typography>
            )}
            {table.source && (
              <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                Source: {table.source}
              </Typography>
            )}
          </Box>

          <Box sx={{ overflow: "auto", maxHeight: 320 }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.75rem",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f8fafc" }}>
                  {table.columns.map((column) => (
                    <th
                      key={column}
                      style={{
                        padding: "8px 12px",
                        textAlign: "left",
                        fontWeight: 600,
                        borderBottom: "1px solid #e5e7eb",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {table.rows.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    style={{ backgroundColor: rowIndex % 2 === 0 ? "#fff" : "#fafafa" }}
                  >
                    {table.columns.map((column) => (
                      <td
                        key={`${rowIndex}-${column}`}
                        style={{
                          padding: "6px 12px",
                          borderBottom: "1px solid #e5e7eb",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {renderCell(row[column])}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
